export enum EditUserTab {
  DATA = 0,
  OPINIONS = 1,
  LOGGING = 2,
  CUSTOM_LOGO = 3,
  BIG_BIK_QUERIES = 4,
}
